module.exports = __webpack_public_path__ + "img/qrcode.b4392c99.webp";